import { DesignRuleValidationIssue } from 'data/types';
import { isErrorSeverity } from 'utils/validation';

export const PTAC_ROOM_NO_EXTERIOR_WALL_CODE = 'ptac-room-no-exterior-wall';

export const PTAC_NON_ADJACENT_SHARE_REASON =
  "A room can only share a zone with an adjoining room. Pick a room that shares a wall with the zone's first room, or give this room its own zone.";

export function hasErrorSeverityIssue(
  issues: readonly DesignRuleValidationIssue[]
): boolean {
  return issues.some((issue) => isErrorSeverity(issue.severity));
}

export function ptacUnitErrorMessage(
  issues: readonly DesignRuleValidationIssue[],
  condenserUniqueId: string
): string | null {
  const issue = issues.find(
    (entry) =>
      isErrorSeverity(entry.severity) &&
      entry.failures.some(
        (failure) => failure.condenserUniqueId === condenserUniqueId
      )
  );
  return issue?.message ?? null;
}
